/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { Dropdown } from "react-bootstrap";
import { DropdownTopbarItemToggler } from "../../../_metronic/_partials/dropdowns";
import {GetUser} from "../../../utils/AuthUtils"
import SVG from "react-inlinesvg"
import {toAbsoluteUrl} from "../../../_metronic/_helpers"
import {useHistory} from "react-router-dom";

export function UserToggler() {
const history = useHistory();

  return (

    <Dropdown className="profiledd mr-5" drop="down" alignRight>
          <Dropdown.Toggle
            as={DropdownTopbarItemToggler}
            id="kt_quick_profile_toggle"
          >
            <div
                className="profile-btn btn btn-icon btn-lg"
                id="kt_quick_profile_toggle"
              >
                <span className="profile-symbol symbol">                
                  <span className="symbol-label">{GetUser().family_name && GetUser().given_name ? GetUser().given_name[0].toUpperCase() + "" + GetUser().family_name[0].toUpperCase() : GetUser().email[0].toUpperCase()}</span>
                 </span>
              </div>
          </Dropdown.Toggle>

          <Dropdown.Menu className="dropdown-menu p-5 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg">

              <div className="profile-header">

              {GetUser().family_name && GetUser().given_name && (<div className="profile-title">{GetUser().given_name + " " + GetUser().family_name}</div>)}

              {GetUser().email && (<div className="profile-mail">{GetUser().email}</div>)}

              </div>

              <div className="profile-logout ml-n5 mr-n5 mb-n5" onClick={() => history.push("/logout")}><SVG src={toAbsoluteUrl("/media/svg/profile/icons-logout.svg")}></SVG> Logout</div>

            </Dropdown.Menu>
        </Dropdown>

    // <OverlayTrigger
    //         placement="bottom"
    //         overlay={<Tooltip id="quick-user-tooltip">View user</Tooltip>}
    //     >
    //       <div className="topbar-item">
    //         <div className="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2"
    //              id="kt_quick_user_toggle">
    //           <>

    //             <span className="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">Hi,</span>
    //             <span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
    //               {user.fullname}
    //             </span>
    //             <span className="symbol symbol-35 symbol-light-success">                
    //                 <span className="symbol-label font-size-h5 font-weight-bold">{user.fullname[0]}</span>
    //             </span>
    //           </>
    //         </div>
    //       </div>
    //     </OverlayTrigger>
  );
}
